import {
  Box,
  Button,
  Snackbar,
  SnackbarCloseReason,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { getCheckpointById } from '../config';
import { useCheckpoints } from '../lib/CheckpointsContext';

const CheckpointInput: React.FC = () => {
  const [input, setInput] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { addItem } = useCheckpoints();

  useEffect(() => {
    setInput('');
  }, [location]);

  const [alertOpen, setAlertOpen] = React.useState(false);

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertOpen(false);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.toUpperCase();
    if (value.length <= 6 && /^[A-Z0-9]*$/.test(value)) {
      setInput(value);
    }
  };

  const handleSubmit = () => {
    if (input.length === 6) {
      const checkpoint = getCheckpointById(input);
      if (checkpoint) {
        addItem(input);
        navigate(`/checkpoint/${input}`);
      } else {
        setAlertOpen(true);
      }
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Box display="flex" justifyContent="center" gap={2}>
        <TextField
          value={input}
          onChange={handleChange}
          variant="outlined"
          inputProps={{ 
            maxLength: 6,
            style: { textTransform: 'uppercase' }
          }}
          sx={{ width: '200px' }}
          placeholder="Syötä 6 merkkiä"
        />
      </Box>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        sx={{ mt: 2 }}
      >
        TARKISTA
      </Button>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={alertOpen}
        autoHideDuration={5000}
        onClose={handleClose}
        message="Rasti ei löytynyt, tarkista rastin numero ja yritä uudestaan."
      />
    </Box>
  );
};

export default CheckpointInput;
